import { Phone, MessageCircle, Mail, MapPin, Clock } from "lucide-react";
import PageHero from "@/components/PageHero";
import { SITE } from "@/data/site";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero
        eyebrow="Get in Touch"
        title="Let’s discuss your next project — over a call, chat or coffee."
        subtitle="One conversation is enough to know whether SkyRise is the right partner for you. Reach out through your preferred channel below."
        image="https://images.unsplash.com/photo-1608237963573-ba0790bc6404?crop=entropy&cs=srgb&fm=jpg&q=85"
        crumbs={[{ label: "Home", to: "/" }, { label: "Contact" }]}
      />

      <section className="py-24 md:py-32 bg-[#F8F7F5]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5 space-y-6">
            <a href={SITE.telHref} className="block bg-white border border-[#E5E7EB] p-8 hover:border-[#C5A059] transition-colors group" data-testid="contact-call-card">
              <div className="flex items-start gap-5">
                <div className="w-12 h-12 grid place-items-center bg-[#0B162C] text-[#C5A059] group-hover:bg-[#C5A059] group-hover:text-white transition-colors"><Phone size={18}/></div>
                <div>
                  <div className="eyebrow">Call Us</div>
                  <div className="font-serif-display text-3xl md:text-4xl text-[#0B162C] mt-1">{SITE.phone}</div>
                  <a href={SITE.tel2Href} className="block text-lg text-[#5C6B7B] mt-1 hover:text-[#C5A059] transition-colors" data-testid="contact-call-second">or {SITE.phone2}</a>
                  <div className="text-sm text-[#5C6B7B] mt-1">Mon – Sat, 9:30 AM to 7:30 PM IST</div>
                </div>
              </div>
            </a>

            <a href={SITE.whatsappHref} target="_blank" rel="noreferrer" className="block bg-white border border-[#E5E7EB] p-8 hover:border-[#C5A059] transition-colors group" data-testid="contact-whatsapp-card">
              <div className="flex items-start gap-5">
                <div className="w-12 h-12 grid place-items-center text-white" style={{background:"#25D366"}}><MessageCircle size={18}/></div>
                <div>
                  <div className="eyebrow">WhatsApp</div>
                  <div className="font-serif-display text-3xl md:text-4xl text-[#0B162C] mt-1">Chat instantly</div>
                  <div className="text-sm text-[#5C6B7B] mt-1">Share plot details, requirements, or upload drawings.</div>
                </div>
              </div>
            </a>

            <a href={`mailto:${SITE.email}`} className="block bg-white border border-[#E5E7EB] p-8 hover:border-[#C5A059] transition-colors" data-testid="contact-email-card">
              <div className="flex items-start gap-5">
                <div className="w-12 h-12 grid place-items-center bg-[#0B162C] text-[#C5A059]"><Mail size={18}/></div>
                <div>
                  <div className="eyebrow">Email</div>
                  <div className="font-serif-display text-2xl text-[#0B162C] mt-1">{SITE.email}</div>
                  <div className="text-sm text-[#5C6B7B] mt-1">Formal enquiries, tenders, RFPs and vendor onboarding.</div>
                </div>
              </div>
            </a>
          </div>

          <div className="md:col-span-7">
            <div className="bg-[#0B162C] text-white p-10 md:p-14">
              <div className="eyebrow mb-6" style={{color:"#C5A059"}}>Head Office</div>
              <h2 className="font-serif-display text-4xl md:text-5xl leading-[1.05]">SkyRise House, Kolkata</h2>
              <div className="mt-8 space-y-5 text-white/80">
                <div className="flex items-start gap-3"><MapPin size={18} className="text-[#C5A059] mt-1"/> <span>{SITE.address}</span></div>
                <div className="flex items-start gap-3"><Clock size={18} className="text-[#C5A059] mt-1"/> <span>Mon – Sat · 9:30 AM to 7:30 PM IST</span></div>
                <div className="flex items-start gap-3"><Phone size={18} className="text-[#C5A059] mt-1"/> <div className="flex flex-col"><a href={SITE.telHref} className="hover:text-[#C5A059]">{SITE.phone}</a><a href={SITE.tel2Href} className="hover:text-[#C5A059]">{SITE.phone2}</a></div></div>
                <div className="flex items-start gap-3"><Mail size={18} className="text-[#C5A059] mt-1"/> <a href={`mailto:${SITE.email}`} className="hover:text-[#C5A059]">{SITE.email}</a></div>
              </div>
            </div>

            <div className="mt-6 overflow-hidden border border-[#E5E7EB]">
              <iframe
                title="SkyRise Location"
                data-testid="contact-map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3818.4090118812533!2d88.32919083008369!3d22.655494708675516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f89d3d8b859085%3A0x3dd7bfd209ed9602!2sBally%20Skyhigh!5e0!3m2!1sen!2sin!4v1786105395219!5m2!1sen!2sin"
                width="100%" height="360" style={{ border: 0 }}
                loading="lazy" referrerPolicy="no-referrer-when-downgrade">
              </iframe>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
